<header class="cab">
  <div class="cab-barra">
    <div class="cab-identidade">
      <button (click)="toggleMenu()" class="cab-menu" title="Abrir menu" aria-label="Abrir menu" data-menu-toggle>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      </button>
      <img class="cab-logo" [src]="isDarkMode() ? brandService.logoTelaNegativo : brandService.logoTela" [alt]="brandService.nomeMarcaTela">
      <span class="cab-divisor"></span>
      <img class="cab-logo cab-logo-flua" [src]="isDarkMode() ? 'marca/flua-negativo.png' : 'marca/flua-positivo.png'" alt="Flua">
      <span class="cab-divisor cab-divisor-produto"></span>
      <span class="cab-produto">Pré-Atendimento</span>
    </div>

    <div class="cab-local">
      <div class="cab-local-item">
        <span class="cab-rotulo">Unidade</span>
        <span class="cab-valor">{{ unitName }}</span>
      </div>
      <span class="cab-divisor"></span>
      <div class="cab-local-item">
        <span class="cab-rotulo">Local</span>
        <span class="cab-valor">{{ currentMachine }}</span>
      </div>
    </div>

    <div class="cab-operador">
      <button type="button" class="cab-chat" (click)="toggleChat()" title="Chat com o médico" aria-label="Chat com o médico">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M21 12c0 4.4-4 8-9 8-1.2 0-2.4-.2-3.4-.6L3 21l1.6-4.2C3.6 15.3 3 13.7 3 12c0-4.4 4-8 9-8s9 3.6 9 8z" />
        </svg>
        <span class="cab-chat-contador" *ngIf="naoLidas > 0">{{ naoLidasTexto }}</span>
      </button>
      <div class="cab-operador-texto">
        <span class="cab-nome">{{ userName }}</span>
        <span class="cab-status">
          <i></i>{{ userProfile }}<ng-container *ngIf="onlineDesde"> · online desde {{ onlineDesde }}</ng-container>
        </span>
      </div>
      <span class="cab-avatar" [title]="userName">{{ iniciais }}</span>
    </div>
  </div>
  <div class="flua-linha"></div>
</header>

<div class="menu-fundo" *ngIf="isMenuOpen"></div>

<aside class="menu" [class.menu-aberto]="isMenuOpen" [attr.aria-hidden]="!isMenuOpen">
  <div class="menu-topo">
    <img class="menu-logo" [src]="isDarkMode() ? brandService.logoTelaNegativo : brandService.logoTela" [alt]="brandService.nomeMarcaTela">
    <button class="menu-fechar" (click)="toggleMenu()" aria-label="Fechar menu">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.8" stroke="currentColor" aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
      </svg>
    </button>
  </div>

  <nav class="menu-itens">
    <a routerLink="/home" routerLinkActive="ativo">Início</a>
    <a *ngIf="hasCashRegisterAccess || isSupervisor" routerLink="/lancamentos-financeiros" routerLinkActive="ativo">Lançamentos financeiros</a>
    <a routerLink="/relatorios" routerLinkActive="ativo">Relatórios</a>
    <a routerLink="/termos" routerLinkActive="ativo">Termos do paciente</a>
    <a *ngIf="isSupervisor" routerLink="/gerenciar-fila" routerLinkActive="ativo">Gerenciar chamada inteligente</a>
    <!-- Gerenciar Guichês desativado temporariamente
    <a *ngIf="isAdmin" routerLink="/computer-settings" routerLinkActive="ativo">Gerenciar guichês</a>
    -->
    <a *ngIf="isAdmin" routerLink="/supervisor" routerLinkActive="ativo">Painel do supervisor</a>
    <a *ngIf="isSupervisor" routerLink="/brand-guide" routerLinkActive="ativo">Editar marca</a>
    <a *ngIf="isAdmin" routerLink="/timer-settings" routerLinkActive="ativo">Gerenciar produtividade</a>
  </nav>

  <div class="menu-rodape">
    <label class="menu-escuro" for="darkModeToggle">
      <span>Modo escuro</span>
      <input id="darkModeToggle" type="checkbox" class="sr-only" (change)="toggleDarkMode()" [checked]="isDarkMode()" />
      <span class="menu-chave" [class.ligada]="isDarkMode()" aria-hidden="true"><i></i></span>
    </label>
    <button class="menu-sair" (click)="logout()">Sair</button>
    <p class="menu-endosso">
      {{ brandService.nomeMarcaTela }} faz parte do ecossistema
      <img [src]="isDarkMode() ? 'marca/flua-negativo.png' : 'marca/flua-positivo.png'" alt="Flua">
    </p>
  </div>
</aside>

<app-chat-medico-painel [aberto]="chatAberto" (fechar)="chatAberto = false" (naoLidasMudou)="agendarNaoLidas()"></app-chat-medico-painel>
